module.exports = __webpack_public_path__ + "img/noobizes-manette@2x.c2c9e037.png";